// @ts-ignore
import { Dispatch, SetStateAction } from 'react'

export const fixNumberToDoubleZero = (input: number): string => {
  return input <= 9 ? `0${input}` : input.toString()
}

export const timeHandler = (countdownTime: number) => {
  const currentTime = new Date()

  const now = currentTime.getTime()
  const countDownDate = currentTime.setSeconds(
    currentTime.getSeconds() + countdownTime
  )

  const distance = countDownDate - now

  const hours = Math.floor(
    (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  )
  const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
  const seconds = Math.floor((distance % (1000 * 60)) / 1000)

  return { hours, minutes, seconds }
}

export const setTimeleft = (
  countdownTime: string,
  setTimeLeft: Dispatch<SetStateAction<string>>,
  setCountdownTime: Dispatch<SetStateAction<string>>
) => {
  if (parseInt(countdownTime) >= 0) {
    const { hours, minutes, seconds } = timeHandler(parseInt(countdownTime))

    return setInterval(() => {
      setTimeLeft(
        `${fixNumberToDoubleZero(hours)}:${fixNumberToDoubleZero(
          minutes
        )}:${fixNumberToDoubleZero(seconds)}`
      )
      setCountdownTime((parseInt(countdownTime) - 1).toString())
    }, 1000)
  }
}
